import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    CopyConractDataStatus: 'idle',
    CopyConractDataError: undefined as any,

    flbelDataList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const CopyConractData = createAsyncThunk('flbelDataSlice/CopyConractData', async ({ flbelData }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ContractMenu_CopyContractData/`,
        prepareData({     lSrcFlbelId: flbelData.SourceContract,      nOptUndKndFlag: flbelData.OptionenUndKuendigungen,     nAntwortMieter: flbelData.OptionenUndKuendigungenAntwort,     nIdx: flbelData.Index,     nKSchutz: flbelData.Konkurenzschutz,     nIhBet: flbelData.IHBeteiligung,     nMfz: flbelData.Mietfreiezeit,     nGarantieGeber: flbelData.AbwRegulierer,     nAusnahme: flbelData.BKAusnahme,     nSollBetrag: flbelData.Sollbetraege,     nBemerkung: flbelData.Notiz,     nBranche: flbelData.Branche,     nStaus: flbelData.Status,     nEinzugdaten: flbelData.DatenEinzug,     nAuszugdaten: flbelData.DatenAuszug,     nVtgDatenUeberschreiben: flbelData.OverwriteContractData,     cVtgIdsToUpdate: flbelData.DestinationContractIds } ),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { CopyConractDataStatus } = getState().flbelDataSlice
        return CopyConractDataStatus !== 'pending'
    }
})

const FlbelDataSlice = createSlice({
    name: 'flbelDataSlice',
    initialState,
    reducers: {
        resetCopyConractDataError: (state) => {
            state.CopyConractDataError = undefined
        },
        removeFromFlbelDataListById: (state, action) => {
            state.flbelDataList = state.flbelDataList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlbelDataListByIds: (state, action) => {
            state.flbelDataList = state.flbelDataList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flbelDataList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.CopyConractDataStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flbelDataList = []
            state.CopyConractDataStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(CopyConractData.pending, (state) => {
            state.CopyConractDataStatus = 'pending'
            state.CopyConractDataError = undefined
        })
        builder.addCase(CopyConractData.fulfilled, (state, action) => {
            state.CopyConractDataStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelDataList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelDataList.push(newItem) }
                else { state.flbelDataList[i] = { ...state.flbelDataList[i], ...newItem } }
            }
        })
        builder.addCase(CopyConractData.rejected, (state, action) => {
            state.CopyConractDataStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.CopyConractDataError = action.error.message
            } else {
                state.CopyConractDataError = action.payload
            }
        })

    }
})

export const {
    resetCopyConractDataError,
    removeFromFlbelDataListById,
    removeFromFlbelDataListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlbelDataSlice.actions
export default FlbelDataSlice.reducer
